import React, { useContext } from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';
import { Button, Text, ThemeContext } from '..';

interface LinkProps {
  contentContainerStyle?: ViewStyle;
  displayRightArrow?: boolean;
  emphasizeSubText?: boolean;
  onLongPress?: Function;
  onPress?: Function;
  style?: any;
  testID?: string;
  text: any;
}

/*eslint-disable react-native/no-unused-styles*/
const getStyles = (theme: Theme): Record<string, Record<string, string | number>> =>
  StyleSheet.create({
    arrow: {
      marginLeft: 10,
    },
    container: {
      flexDirection: 'row',
      alignItems: 'baseline',
    },
    link: {
      color: theme.colors.frame.linkColor,
      textAlign: 'center',
      fontSize: 18,
    },
    underline: {
      textDecorationLine: 'underline',
    },
  });

export const Link = ({
  text,
  contentContainerStyle,
  style,
  emphasizeSubText,
  displayRightArrow,
  ...rest
}: LinkProps): React.JSX.Element=> {
  const theme = useContext(ThemeContext);
  const styles = getStyles(theme);

  const textStyles = [styles.link, style, emphasizeSubText && styles.underline];
  const iconColor = style?.color || styles.link.color;

  const { IconComponent, icons } = theme;
  const hasRightArrow = displayRightArrow === undefined ? theme.buttons.LINK.hasRightArrow : displayRightArrow;

  return (
    <View style={styles.container}>
      <Button {...rest} style={[contentContainerStyle]}>
        <Text style={textStyles}>{text}</Text>
      </Button>
      {hasRightArrow && (
        <View style={styles.arrow}>{<IconComponent color={iconColor} name={icons.arrowRight} size={14} />}</View>
      )}
    </View>
  );
};
